export const PROFILE_HEADER_ID = "profile-header";

export const setDynamicHeaderColorCssVar = (profileHeaderEl: HTMLElement, { backgroundColor, color }) => {
    if (!profileHeaderEl) {
        throw new Error("profileHeaderEl is undefined, please fix it dev!");
    }

    profileHeaderEl.style.setProperty("--color-profile-dynamic-bg-color", backgroundColor);
    profileHeaderEl.style.setProperty("--color-profile-dynamic-text-color", color);
};
